import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

const StoreLink = ({href, text, className, onClick, platform}) => {
  const {i18n} = useContext(Context)

  return (
    <a
      aria-label={i18n.t(`FOOTER.STORES.LINK_ARIA_LABEL_${platform.toUpperCase()}`)}
      href={href}
      title={text}
      target="_blank"
      className={className}
      onClick={onClick}
      rel="noopener noreferrer"
    >
      {text}
    </a>
  )
}
StoreLink.displayName = 'StoreLink'

StoreLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  platform: PropTypes.string
}

export {StoreLink}
